// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menuOptions_Gim00 {
    flex-direction: column;
    gap: 10px;
    list-style: none;
    position: fixed;
    top: 0;
    left: 0;
    top: 23px;
    z-index: 999;
    padding: 4px;
    border-radius: 8px;
    background: var(--fa-background);
    box-shadow: 0 2px 10px var(--_0000001a-shadow);

    li {
        border-radius: 10px;
        background: var(--white-background);
        padding: 8px 16px;
        cursor: pointer;
        text-align: left;
        font-size: 14px;
        color: var(--_3-color);
        border-radius: 4px;

        &:hover {
            background-color: var(--f5-background);
        }

    }
}



.groupTitle_WGYp8 {
    font-size: 12px;
    padding: 8px;
    color: var(--black-color);
    background-color: var(--f4-background);
  }



.chatMenu_Sr5UU {
    background: var(--white-background);
    height: 100%;
    width: 100%;
    min-width: 200px;
    z-index: 1;
    display: flex;
    flex-direction: column;

    .agentsContainer_E_Ywe {
        height: 100%;
        box-sizing: border-box;
    }

    .chatsContainer_Bkroa {
        height: calc(100% - 76px);
        overflow-y: auto;
        padding: 10px 0px;
        box-sizing: border-box;

        &::-webkit-scrollbar {
            display: none;
        }

        h3 {
            font-weight: 600;
            margin: 0;
            font-size: 10px;
            color: var(--black-color);
        }

        span {
            font-weight: 600;
            margin: 0;
            font-size: 10px;
            color: var(--_8a-color);
            padding: 5px 0;
            text-align: center;
        }

        .noFilesContainer_tCEmN {

            h3,
            h4 {
                max-width: 95%;
                font-size: 15px;
                text-align: center;
                font-weight: 600;
                color: var(--_67-color);
            }
        }

        ul {
            padding-left: 0px;
            margin: 2px 0px;
            display: inline-flex;
            flex-direction: column;
            gap: 2px;
            width: 100%;

            li {
                list-style: none;
                position: relative;
                padding: 8px;
                font-size: 12px;
                border-radius: 12px;
                -webkit-border-radius: 12px;
                -moz-border-radius: 12px;
                -ms-border-radius: 12px;
                -o-border-radius: 12px;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: space-between;
                gap: 5px;
                height: 26px;

                &:hover {
                    background-color: var(--ececf1-background);

                    .pinnedIcon_GnzEb {
                        display: none;

                    }

                    .chatMenuSettings_eBGJM {
                        display: block;
                    }
                }

                input {
                    background-color: transparent;
                    border: none;
                    outline: none;
                }

                .selectedChat_fkQZ6 {
                    background: transparent;
                    font-weight: 600;
                    font-size: 10px;
                    color: var(--_8a-color);
                }
            }

            .icon_xKDZI {
                opacity: 0;
            }

            .moreButton_gZVWr {
                display: none;
                border: none;
                background: none;
                padding: 4px;
                cursor: pointer;
                opacity: 0;
                align-items: center;
                justify-content: center;
                transition: opacity 0.2s ease-in-out;
                margin-left: auto;

                img {
                    width: 18px;
                    height: 18px;
                }
            }

            li:hover .moreButton_gZVWr {
                opacity: 0.7;
                display: flex;
            }

            .moreButton_gZVWr:hover {
                opacity: 1 !important;
                background: var(--ea-background);
                border-radius: 4px;
            }

            li:hover .icon_xKDZI {
                opacity: 1;
            }

            .agentInfo_ihl71 {
                display: flex;
                align-items: center;
                gap: 5px;
                min-width: 70%;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;

                .agentNameQuantityConversations_ZKEpG {
                    display: flex;
                    flex-direction: column;

                    span {
                        padding: 0;
                    }
                }
            }

            .liSinHover_Ihr9p{
                background: transparent;
                padding: 0px;
                border-radius: 0px;
                &:hover{
                    background: transparent;
                }
            }

            .pinnedIcon_GnzEb {
                display: block;


                svg {
                    fill: var(--_2-color);
                    color: var(--_2-color);
                    height: 15px;
                    width: 15px;
                }

                .pinnedIconSvg_yP1y3 {
                    fill: var(--_10a37f-background);
                    color: var(--_10a37f-background);
                }
            }

            img {
                width: 32px;
                height: 32px;
                border-radius: 999px;
                -webkit-border-radius: 999px;
                -moz-border-radius: 999px;
                -ms-border-radius: 999px;
                -o-border-radius: 999px;
            }
        }

        .active_zuELQ {
            background-color: var(--ececf1-background);
        }
    }
}

@media (width <=768px) {
    .chatMenu_Sr5UU {
        .chatsContainer_Bkroa {
            height: 65vh;
        }
    }

    .searchInputWrapper_QJget {
        display: flex;
        align-items: center;
        background: var(--white-background);
        height: 36px;
        min-height: 36px;
        border: 1px solid var(--d9d9e3-border);
        border-radius: 8px;
        padding: 0px 9px;
        -webkit-border-radius: 8px;
        -moz-border-radius: 8px;
        -ms-border-radius: 8px;
        -o-border-radius: 8px;
        width: 100%;

        .searchIcon_AG2Vy {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 24px;
            height: 24px;
            color: var(--_6-color);
        }

        .searchInput_kjZad {
            flex: 1 1;
            padding: 8px;
            border: none;
            background: transparent;
            font-size: 14px;
            outline: none;
            width: 100%;

            &::placeholder {
                color: var(--_6-color);
            }
        }
    }
}

@media (width <=500px) {
    .chatMenu_Sr5UU {
        display: none;
    }
}

.chatMenuSettings_eBGJM {
    display: none;

    button {
        background-color: transparent;
        outline: none;
        border: none;
        cursor: pointer;
        position: absolute;
        top: 50%;
        right: 5px;
        transform: translateY(-50%);
    }

    .verticalDots_a8FOV {
        transform: rotate(90deg);
        -webkit-transform: rotate(90deg);
        -moz-transform: rotate(90deg);
        -ms-transform: rotate(90deg);
        -o-transform: rotate(90deg);
    }
}





.shadowContainer_zzMMm {
    background-color: var(--_52525261-background);
    transition: all 300ms;
    margin-left: 6px;
    width: 15px;
    height: 27px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 300ms;
    position: absolute;
    top: 50%;
    left: 50%;
    /* border-radius: 4px; */
    transform: translate(-50%, -50%);
    opacity: 0;
}





.noChats_hLn69 {
    flex: 1 1;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    color: var(--_3a-color);
    gap: 10px;
    font-weight: 600;
    justify-content: center;
    padding-top: 0;
    height: 93%;
    text-align: center;
    border: 2px dashed var(--d9d9e3-border);

    p {
        margin: 0;
        font-size: 14px;
        max-width: 95%;
        font-size: 15px;
        text-align: center;
        font-weight: 600;
        color: var(--_67-color);
    }
}





.noFilesContainer_tCEmN {
    flex: 1 1;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    border: 2px dashed var(--d9d9e3-border);
    color: var(--_67-color);
    gap: 10px;
    font-weight: 600;
    cursor: grab;
    height: 100%;

    h3,
    h4 {
        max-width: 85%;
        font-size: 26px;
        text-align: center;
        font-weight: 600;
        color: var(--_67-color);
    }

    svg {
        max-width: 110px;
        height: 110px;
        width: 70px;
        color: var(--_e6-color) !important;
    }
}



.asideBar_YziMQ {
    background: linear-gradient(0deg, var(--e9e9e96d-background) 21%, var(--f5-background) 100%);
    height: 0px;
    box-sizing: border-box;
    top: 0;
    z-index: 2;
    transition: left 0.3s ease;
    -webkit-transition: left 0.3s ease;
    -moz-transition: left 0.3s ease;
    -ms-transition: left 0.3s ease;
    -o-transition: left 0.3s ease;
    position: initial;
    left: 0;
    flex: 20 1;
    padding: 4px 6px 0px;
}

.mobileMenu_x_h6L {
    position: absolute;
    width: 100vw;
}

.searchContainerL_AEVNT {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0px 4px 0px;
    cursor: pointer;

    img {
        transition: filter 0.1s ease;
        -webkit-transition: filter 0.1s ease;
        -moz-transition: filter 0.1s ease;
        -ms-transition: filter 0.1s ease;
        -o-transition: filter 0.1s ease;
    }
}



.searchIconsWrappers_b7d1Y {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    background: var(--ececf1-background);
    cursor: pointer;
    -webkit-user-select: none;
    user-select: none;
    border-radius: 3px;
    font-size: 10px;
    color: #696969;
}






.goToAgents_mGqDk {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;

    &:hover {
        .chatMenuSettings_eBGJM {
            display: block;
        }

        .pinnedIcon_GnzEb {
            display: none;
        }

        .selectedAgentContainer_HkP7O {
            padding-right: 12px;
        }
    }

    .selectedAgentContainer_HkP7O {
        position: relative;
        display: flex;
        align-items: center;
        gap: 5px;
    }

    img {
        height: 25px;
        width: 25px;
        border-radius: 999px;
        -webkit-border-radius: 999px;
        -moz-border-radius: 999px;
        -ms-border-radius: 999px;
        -o-border-radius: 999px;
    }

    .verticalDots_a8FOV {
        height: 20px;
        width: 20px;
        margin-right: -12px;
    }
}






.dotsWrapperHover_RYyew {}

.dotsWrapperHover_RYyew:hover {
    .shadowContainer_zzMMm {
        opacity: 1;
    }
}













.dotsWrapperHoverHorizontal_WusFf {}

.dotsWrapperHoverHorizontal_WusFf:hover {
    .shadowContainerHorizontal_qyWVk {
        opacity: 1;
    }
}


.shadowContainerHorizontal_qyWVk {
    background-color: var(--_52525261-background);
    transition: all 300ms;
    margin-top: -1.2px;
    width: 27px;
    height: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 300ms;
    position: absolute;
    border-radius: 4px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 0;
}












.communitiContainer_YYMj_ {
    flex: 1 1;
    position: relative;
    width: 100%;
    background: var(--f1-background);
}

.communiti_YiPQl {
    all: unset;
    display: flex;
    align-items: center;
    background-color: var(--_16c0982e-background);
    color: var(--16C097-fill);
    position: relative;
    bottom: 0;
    margin: 0px 0px 58px 0px;
    border-radius: 9px;
    padding: 8px 8px 8px 8px;
    flex: 1 1;
    font-size: 12px;
    font-weight: bold;
    gap: 8px;
    width: 92%;
    cursor: pointer;

    svg {
        width: 20px;
    }

    &:hover {
        background-color: var(--f5-background);
    }
}

.imageHover_eMzkA {
    position: relative;
    display: flex;
    align-items: center;
    gap: 5px;
    background-color: var(--_16c0982e-background);
    color: var(--16C097-fill);
    position: relative;
    bottom: 0;
    margin-bottom:10px;
    border-radius: 9px;
    padding: 8px 8px 8px 8px;
    flex: 1 1;
    font-size: 12px;
    font-weight: bold;
    gap: 8px;
    width: 92%;
    cursor: pointer;

    svg {
        width: 22px;
        padding:0px
    }
    img {
        width: 22px;
        padding:0px
    }

    &:hover {
        background-color: var(--f5-background);
    }
  }
  
  /* .imageHover:hover {
    .shadowContainerSearch {
      opacity: 1;
    }
  }
  
.shadowContainerSearch{
    background-color: var(--_52525261-background);
    transition: all 300ms;
    width: 29px;
    height: 30px;
    left: 9%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 300ms;
    position: absolute;
    top: 50%;
    border-radius: 4px;
    transform: translate(-50%, -50%);
    opacity: 0;
    pointer-events: none;
  } */
  
  
  
  .count_GitNf{
    position: absolute;
    background-color: var(--_2-color);
    color: var(--white-background);
    padding: 2px 3px;
    border-radius: 6px;
    top: -2px;
    right: 0px;
    font-size: 7px;
  }`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/ChatExplorer/ChatExplorer.module.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,eAAe;IACf,MAAM;IACN,OAAO;IACP,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,gCAAgC;IAChC,8CAA8C;;IAE9C;QACI,mBAAmB;QACnB,mCAAmC;QACnC,iBAAiB;QACjB,eAAe;QACf,gBAAgB;QAChB,eAAe;QACf,sBAAsB;QACtB,kBAAkB;;QAElB;YACI,sCAAsC;QAC1C;;IAEJ;AACJ;;;;AAIA;IACI,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,sCAAsC;EACxC;;;;AAIF;IACI,mCAAmC;IACnC,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,UAAU;IACV,aAAa;IACb,sBAAsB;;IAEtB;QACI,YAAY;QACZ,sBAAsB;IAC1B;;IAEA;QACI,yBAAyB;QACzB,gBAAgB;QAChB,iBAAiB;QACjB,sBAAsB;;QAEtB;YACI,aAAa;QACjB;;QAEA;YACI,gBAAgB;YAChB,SAAS;YACT,eAAe;YACf,yBAAyB;QAC7B;;QAEA;YACI,gBAAgB;YAChB,SAAS;YACT,eAAe;YACf,uBAAuB;YACvB,cAAc;YACd,kBAAkB;QACtB;;QAEA;;YAEI;;gBAEI,cAAc;gBACd,eAAe;gBACf,kBAAkB;gBAClB,gBAAgB;gBAChB,uBAAuB;YAC3B;QACJ;;QAEA;YACI,iBAAiB;YACjB,eAAe;YACf,oBAAoB;YACpB,sBAAsB;YACtB,QAAQ;YACR,WAAW;;YAEX;gBACI,gBAAgB;gBAChB,kBAAkB;gBAClB,YAAY;gBACZ,eAAe;gBACf,mBAAmB;gBACnB,2BAA2B;gBAC3B,wBAAwB;gBACxB,uBAAuB;gBACvB,sBAAsB;gBACtB,eAAe;gBACf,aAAa;gBACb,mBAAmB;gBACnB,8BAA8B;gBAC9B,QAAQ;gBACR,YAAY;;gBAEZ;oBACI,0CAA0C;;oBAE1C;wBACI,aAAa;;oBAEjB;;oBAEA;wBACI,cAAc;oBAClB;gBACJ;;gBAEA;oBACI,6BAA6B;oBAC7B,YAAY;oBACZ,aAAa;gBACjB;;gBAEA;oBACI,uBAAuB;oBACvB,gBAAgB;oBAChB,eAAe;oBACf,uBAAuB;gBAC3B;YACJ;;YAEA;gBACI,UAAU;YACd;;YAEA;gBACI,aAAa;gBACb,YAAY;gBACZ,gBAAgB;gBAChB,YAAY;gBACZ,eAAe;gBACf,UAAU;gBACV,mBAAmB;gBACnB,uBAAuB;gBACvB,oCAAoC;gBACpC,iBAAiB;;gBAEjB;oBACI,WAAW;oBACX,YAAY;gBAChB;YACJ;;YAEA;gBACI,YAAY;gBACZ,aAAa;YACjB;;YAEA;gBACI,qBAAqB;gBACrB,gCAAgC;gBAChC,kBAAkB;YACtB;;YAEA;gBACI,UAAU;YACd;;YAEA;gBACI,aAAa;gBACb,mBAAmB;gBACnB,QAAQ;gBACR,cAAc;gBACd,gBAAgB;gBAChB,mBAAmB;gBACnB,uBAAuB;;gBAEvB;oBACI,aAAa;oBACb,sBAAsB;;oBAEtB;wBACI,UAAU;oBACd;gBACJ;YACJ;;YAEA;gBACI,uBAAuB;gBACvB,YAAY;gBACZ,kBAAkB;gBAClB;oBACI,uBAAuB;gBAC3B;YACJ;;YAEA;gBACI,cAAc;;;gBAGd;oBACI,qBAAqB;oBACrB,sBAAsB;oBACtB,YAAY;oBACZ,WAAW;gBACf;;gBAEA;oBACI,+BAA+B;oBAC/B,gCAAgC;gBACpC;YACJ;;YAEA;gBACI,WAAW;gBACX,YAAY;gBACZ,oBAAoB;gBACpB,4BAA4B;gBAC5B,yBAAyB;gBACzB,wBAAwB;gBACxB,uBAAuB;YAC3B;QACJ;;QAEA;YACI,0CAA0C;QAC9C;IACJ;AACJ;;AAEA;IACI;QACI;YACI,YAAY;QAChB;IACJ;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,mCAAmC;QACnC,YAAY;QACZ,gBAAgB;QAChB,sCAAsC;QACtC,kBAAkB;QAClB,gBAAgB;QAChB,0BAA0B;QAC1B,uBAAuB;QACvB,sBAAsB;QACtB,qBAAqB;QACrB,WAAW;;QAEX;YACI,aAAa;YACb,mBAAmB;YACnB,uBAAuB;YACvB,WAAW;YACX,YAAY;YACZ,sBAAsB;QAC1B;;QAEA;YACI,SAAO;YACP,YAAY;YACZ,YAAY;YACZ,uBAAuB;YACvB,eAAe;YACf,aAAa;YACb,WAAW;;YAEX;gBACI,sBAAsB;YAC1B;QACJ;IACJ;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,aAAa;;IAEb;QACI,6BAA6B;QAC7B,aAAa;QACb,YAAY;QACZ,eAAe;QACf,kBAAkB;QAClB,QAAQ;QACR,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,wBAAwB;QACxB,gCAAgC;QAChC,6BAA6B;QAC7B,4BAA4B;QAC5B,2BAA2B;IAC/B;AACJ;;;;;;AAMA;IACI,6CAA6C;IAC7C,qBAAqB;IACrB,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,wBAAwB;IACxB,gCAAgC;IAChC,UAAU;AACd;;;;;;AAMA;IACI,SAAS;IACT,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,uCAAuC;;IAEvC;QACI,SAAS;QACT,eAAe;QACf,cAAc;QACd,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,uBAAuB;IAC3B;AACJ;;;;;;AAMA;IACI,SAAO;IACP,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,uCAAuC;IACvC,uBAAuB;IACvB,SAAS;IACT,gBAAgB;IAChB,YAAY;IACZ,YAAY;;IAEZ;;QAEI,cAAc;QACd,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;QAChB,aAAa;QACb,WAAW;QACX,kCAAkC;IACtC;AACJ;;;;AAIA;IACI,4FAA4F;IAC5F,WAAW;IACX,sBAAsB;IACtB,MAAM;IACN,UAAU;IACV,0BAA0B;IAC1B,kCAAkC;IAClC,+BAA+B;IAC/B,8BAA8B;IAC9B,6BAA6B;IAC7B,iBAAiB;IACjB,OAAO;IACP,UAAQ;IACR,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;IACpB,eAAe;;IAEf;QACI,4BAA4B;QAC5B,oCAAoC;QACpC,iCAAiC;QACjC,gCAAgC;QAChC,+BAA+B;IACnC;AACJ;;;;AAIA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,eAAe;IACf,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;;;;;;AAOA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;;IAEnB;QACI;YACI,cAAc;QAClB;;QAEA;YACI,aAAa;QACjB;;QAEA;YACI,mBAAmB;QACvB;IACJ;;IAEA;QACI,kBAAkB;QAClB,aAAa;QACb,mBAAmB;QACnB,QAAQ;IACZ;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,oBAAoB;QACpB,4BAA4B;QAC5B,yBAAyB;QACzB,wBAAwB;QACxB,uBAAuB;IAC3B;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,mBAAmB;IACvB;AACJ;;;;;;;AAOA,yBAAmB;;AAEnB;IACI;QACI,UAAU;IACd;AACJ;;;;;;;;;;;;;;AAcA,mCAA6B;;AAE7B;IACI;QACI,UAAU;IACd;AACJ;;;AAGA;IACI,6CAA6C;IAC7C,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,UAAU;AACd;;;;;;;;;;;;;AAaA;IACI,SAAO;IACP,kBAAkB;IAClB,WAAW;IACX,gCAAgC;AACpC;;AAEA;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,6CAA6C;IAC7C,yBAAyB;IACzB,kBAAkB;IAClB,SAAS;IACT,wBAAwB;IACxB,kBAAkB;IAClB,wBAAwB;IACxB,SAAS;IACT,eAAe;IACf,iBAAiB;IACjB,QAAQ;IACR,UAAU;IACV,eAAe;;IAEf;QACI,WAAW;IACf;;IAEA;QACI,sCAAsC;IAC1C;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,6CAA6C;IAC7C,yBAAyB;IACzB,kBAAkB;IAClB,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,wBAAwB;IACxB,SAAS;IACT,eAAe;IACf,iBAAiB;IACjB,QAAQ;IACR,UAAU;IACV,eAAe;;IAEf;QACI,WAAW;QACX;IACJ;IACA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,sCAAsC;IAC1C;EACF;;EAEA;;;;;;;;;;;;;;;;;;;;;;KAsBG;;;;EAIH;IACE,kBAAkB;IAClB,iCAAiC;IACjC,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,cAAc;EAChB","sourcesContent":[".menuOptions {\n    flex-direction: column;\n    gap: 10px;\n    list-style: none;\n    position: fixed;\n    top: 0;\n    left: 0;\n    top: 23px;\n    z-index: 999;\n    padding: 4px;\n    border-radius: 8px;\n    background: var(--fa-background);\n    box-shadow: 0 2px 10px var(--_0000001a-shadow);\n\n    li {\n        border-radius: 10px;\n        background: var(--white-background);\n        padding: 8px 16px;\n        cursor: pointer;\n        text-align: left;\n        font-size: 14px;\n        color: var(--_3-color);\n        border-radius: 4px;\n\n        &:hover {\n            background-color: var(--f5-background);\n        }\n\n    }\n}\n\n\n\n.groupTitle {\n    font-size: 12px;\n    padding: 8px;\n    color: var(--black-color);\n    background-color: var(--f4-background);\n  }\n\n\n\n.chatMenu {\n    background: var(--white-background);\n    height: 100%;\n    width: 100%;\n    min-width: 200px;\n    z-index: 1;\n    display: flex;\n    flex-direction: column;\n\n    .agentsContainer {\n        height: 100%;\n        box-sizing: border-box;\n    }\n\n    .chatsContainer {\n        height: calc(100% - 76px);\n        overflow-y: auto;\n        padding: 10px 0px;\n        box-sizing: border-box;\n\n        &::-webkit-scrollbar {\n            display: none;\n        }\n\n        h3 {\n            font-weight: 600;\n            margin: 0;\n            font-size: 10px;\n            color: var(--black-color);\n        }\n\n        span {\n            font-weight: 600;\n            margin: 0;\n            font-size: 10px;\n            color: var(--_8a-color);\n            padding: 5px 0;\n            text-align: center;\n        }\n\n        .noFilesContainer {\n\n            h3,\n            h4 {\n                max-width: 95%;\n                font-size: 15px;\n                text-align: center;\n                font-weight: 600;\n                color: var(--_67-color);\n            }\n        }\n\n        ul {\n            padding-left: 0px;\n            margin: 2px 0px;\n            display: inline-flex;\n            flex-direction: column;\n            gap: 2px;\n            width: 100%;\n\n            li {\n                list-style: none;\n                position: relative;\n                padding: 8px;\n                font-size: 12px;\n                border-radius: 12px;\n                -webkit-border-radius: 12px;\n                -moz-border-radius: 12px;\n                -ms-border-radius: 12px;\n                -o-border-radius: 12px;\n                cursor: pointer;\n                display: flex;\n                align-items: center;\n                justify-content: space-between;\n                gap: 5px;\n                height: 26px;\n\n                &:hover {\n                    background-color: var(--ececf1-background);\n\n                    .pinnedIcon {\n                        display: none;\n\n                    }\n\n                    .chatMenuSettings {\n                        display: block;\n                    }\n                }\n\n                input {\n                    background-color: transparent;\n                    border: none;\n                    outline: none;\n                }\n\n                .selectedChat {\n                    background: transparent;\n                    font-weight: 600;\n                    font-size: 10px;\n                    color: var(--_8a-color);\n                }\n            }\n\n            .icon {\n                opacity: 0;\n            }\n\n            .moreButton {\n                display: none;\n                border: none;\n                background: none;\n                padding: 4px;\n                cursor: pointer;\n                opacity: 0;\n                align-items: center;\n                justify-content: center;\n                transition: opacity 0.2s ease-in-out;\n                margin-left: auto;\n\n                img {\n                    width: 18px;\n                    height: 18px;\n                }\n            }\n\n            li:hover .moreButton {\n                opacity: 0.7;\n                display: flex;\n            }\n\n            .moreButton:hover {\n                opacity: 1 !important;\n                background: var(--ea-background);\n                border-radius: 4px;\n            }\n\n            li:hover .icon {\n                opacity: 1;\n            }\n\n            .agentInfo {\n                display: flex;\n                align-items: center;\n                gap: 5px;\n                min-width: 70%;\n                overflow: hidden;\n                white-space: nowrap;\n                text-overflow: ellipsis;\n\n                .agentNameQuantityConversations {\n                    display: flex;\n                    flex-direction: column;\n\n                    span {\n                        padding: 0;\n                    }\n                }\n            }\n\n            .liSinHover{\n                background: transparent;\n                padding: 0px;\n                border-radius: 0px;\n                &:hover{\n                    background: transparent;\n                }\n            }\n\n            .pinnedIcon {\n                display: block;\n\n\n                svg {\n                    fill: var(--_2-color);\n                    color: var(--_2-color);\n                    height: 15px;\n                    width: 15px;\n                }\n\n                .pinnedIconSvg {\n                    fill: var(--_10a37f-background);\n                    color: var(--_10a37f-background);\n                }\n            }\n\n            img {\n                width: 32px;\n                height: 32px;\n                border-radius: 999px;\n                -webkit-border-radius: 999px;\n                -moz-border-radius: 999px;\n                -ms-border-radius: 999px;\n                -o-border-radius: 999px;\n            }\n        }\n\n        .active {\n            background-color: var(--ececf1-background);\n        }\n    }\n}\n\n@media (width <=768px) {\n    .chatMenu {\n        .chatsContainer {\n            height: 65vh;\n        }\n    }\n\n    .searchInputWrapper {\n        display: flex;\n        align-items: center;\n        background: var(--white-background);\n        height: 36px;\n        min-height: 36px;\n        border: 1px solid var(--d9d9e3-border);\n        border-radius: 8px;\n        padding: 0px 9px;\n        -webkit-border-radius: 8px;\n        -moz-border-radius: 8px;\n        -ms-border-radius: 8px;\n        -o-border-radius: 8px;\n        width: 100%;\n\n        .searchIcon {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            width: 24px;\n            height: 24px;\n            color: var(--_6-color);\n        }\n\n        .searchInput {\n            flex: 1;\n            padding: 8px;\n            border: none;\n            background: transparent;\n            font-size: 14px;\n            outline: none;\n            width: 100%;\n\n            &::placeholder {\n                color: var(--_6-color);\n            }\n        }\n    }\n}\n\n@media (width <=500px) {\n    .chatMenu {\n        display: none;\n    }\n}\n\n.chatMenuSettings {\n    display: none;\n\n    button {\n        background-color: transparent;\n        outline: none;\n        border: none;\n        cursor: pointer;\n        position: absolute;\n        top: 50%;\n        right: 5px;\n        transform: translateY(-50%);\n    }\n\n    .verticalDots {\n        transform: rotate(90deg);\n        -webkit-transform: rotate(90deg);\n        -moz-transform: rotate(90deg);\n        -ms-transform: rotate(90deg);\n        -o-transform: rotate(90deg);\n    }\n}\n\n\n\n\n\n.shadowContainer {\n    background-color: var(--_52525261-background);\n    transition: all 300ms;\n    margin-left: 6px;\n    width: 15px;\n    height: 27px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 300ms;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    /* border-radius: 4px; */\n    transform: translate(-50%, -50%);\n    opacity: 0;\n}\n\n\n\n\n\n.noChats {\n    flex: 1 1;\n    border-radius: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    color: var(--_3a-color);\n    gap: 10px;\n    font-weight: 600;\n    justify-content: center;\n    padding-top: 0;\n    height: 93%;\n    text-align: center;\n    border: 2px dashed var(--d9d9e3-border);\n\n    p {\n        margin: 0;\n        font-size: 14px;\n        max-width: 95%;\n        font-size: 15px;\n        text-align: center;\n        font-weight: 600;\n        color: var(--_67-color);\n    }\n}\n\n\n\n\n\n.noFilesContainer {\n    flex: 1;\n    border-radius: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    border: 2px dashed var(--d9d9e3-border);\n    color: var(--_67-color);\n    gap: 10px;\n    font-weight: 600;\n    cursor: grab;\n    height: 100%;\n\n    h3,\n    h4 {\n        max-width: 85%;\n        font-size: 26px;\n        text-align: center;\n        font-weight: 600;\n        color: var(--_67-color);\n    }\n\n    svg {\n        max-width: 110px;\n        height: 110px;\n        width: 70px;\n        color: var(--_e6-color) !important;\n    }\n}\n\n\n\n.asideBar {\n    background: linear-gradient(0deg, var(--e9e9e96d-background) 21%, var(--f5-background) 100%);\n    height: 0px;\n    box-sizing: border-box;\n    top: 0;\n    z-index: 2;\n    transition: left 0.3s ease;\n    -webkit-transition: left 0.3s ease;\n    -moz-transition: left 0.3s ease;\n    -ms-transition: left 0.3s ease;\n    -o-transition: left 0.3s ease;\n    position: initial;\n    left: 0;\n    flex: 20;\n    padding: 4px 6px 0px;\n}\n\n.mobileMenu {\n    position: absolute;\n    width: 100vw;\n}\n\n.searchContainerL {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0px 4px 0px;\n    cursor: pointer;\n\n    img {\n        transition: filter 0.1s ease;\n        -webkit-transition: filter 0.1s ease;\n        -moz-transition: filter 0.1s ease;\n        -ms-transition: filter 0.1s ease;\n        -o-transition: filter 0.1s ease;\n    }\n}\n\n\n\n.searchIconsWrappers {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 18px;\n    height: 18px;\n    background: var(--ececf1-background);\n    cursor: pointer;\n    -webkit-user-select: none;\n    user-select: none;\n    border-radius: 3px;\n    font-size: 10px;\n    color: #696969;\n}\n\n\n\n\n\n\n.goToAgents {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 10px;\n\n    &:hover {\n        .chatMenuSettings {\n            display: block;\n        }\n\n        .pinnedIcon {\n            display: none;\n        }\n\n        .selectedAgentContainer {\n            padding-right: 12px;\n        }\n    }\n\n    .selectedAgentContainer {\n        position: relative;\n        display: flex;\n        align-items: center;\n        gap: 5px;\n    }\n\n    img {\n        height: 25px;\n        width: 25px;\n        border-radius: 999px;\n        -webkit-border-radius: 999px;\n        -moz-border-radius: 999px;\n        -ms-border-radius: 999px;\n        -o-border-radius: 999px;\n    }\n\n    .verticalDots {\n        height: 20px;\n        width: 20px;\n        margin-right: -12px;\n    }\n}\n\n\n\n\n\n\n.dotsWrapperHover {}\n\n.dotsWrapperHover:hover {\n    .shadowContainer {\n        opacity: 1;\n    }\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n.dotsWrapperHoverHorizontal {}\n\n.dotsWrapperHoverHorizontal:hover {\n    .shadowContainerHorizontal {\n        opacity: 1;\n    }\n}\n\n\n.shadowContainerHorizontal {\n    background-color: var(--_52525261-background);\n    transition: all 300ms;\n    margin-top: -1.2px;\n    width: 27px;\n    height: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 300ms;\n    position: absolute;\n    border-radius: 4px;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    opacity: 0;\n}\n\n\n\n\n\n\n\n\n\n\n\n\n.communitiContainer {\n    flex: 1;\n    position: relative;\n    width: 100%;\n    background: var(--f1-background);\n}\n\n.communiti {\n    all: unset;\n    display: flex;\n    align-items: center;\n    background-color: var(--_16c0982e-background);\n    color: var(--16C097-fill);\n    position: relative;\n    bottom: 0;\n    margin: 0px 0px 58px 0px;\n    border-radius: 9px;\n    padding: 8px 8px 8px 8px;\n    flex: 1 1;\n    font-size: 12px;\n    font-weight: bold;\n    gap: 8px;\n    width: 92%;\n    cursor: pointer;\n\n    svg {\n        width: 20px;\n    }\n\n    &:hover {\n        background-color: var(--f5-background);\n    }\n}\n\n.imageHover {\n    position: relative;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    background-color: var(--_16c0982e-background);\n    color: var(--16C097-fill);\n    position: relative;\n    bottom: 0;\n    margin-bottom:10px;\n    border-radius: 9px;\n    padding: 8px 8px 8px 8px;\n    flex: 1 1;\n    font-size: 12px;\n    font-weight: bold;\n    gap: 8px;\n    width: 92%;\n    cursor: pointer;\n\n    svg {\n        width: 22px;\n        padding:0px\n    }\n    img {\n        width: 22px;\n        padding:0px\n    }\n\n    &:hover {\n        background-color: var(--f5-background);\n    }\n  }\n  \n  /* .imageHover:hover {\n    .shadowContainerSearch {\n      opacity: 1;\n    }\n  }\n  \n.shadowContainerSearch{\n    background-color: var(--_52525261-background);\n    transition: all 300ms;\n    width: 29px;\n    height: 30px;\n    left: 9%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 300ms;\n    position: absolute;\n    top: 50%;\n    border-radius: 4px;\n    transform: translate(-50%, -50%);\n    opacity: 0;\n    pointer-events: none;\n  } */\n  \n  \n  \n  .count{\n    position: absolute;\n    background-color: var(--_2-color);\n    color: var(--white-background);\n    padding: 2px 3px;\n    border-radius: 6px;\n    top: -2px;\n    right: 0px;\n    font-size: 7px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menuOptions": `menuOptions_Gim00`,
	"groupTitle": `groupTitle_WGYp8`,
	"chatMenu": `chatMenu_Sr5UU`,
	"agentsContainer": `agentsContainer_E_Ywe`,
	"chatsContainer": `chatsContainer_Bkroa`,
	"noFilesContainer": `noFilesContainer_tCEmN`,
	"pinnedIcon": `pinnedIcon_GnzEb`,
	"chatMenuSettings": `chatMenuSettings_eBGJM`,
	"selectedChat": `selectedChat_fkQZ6`,
	"icon": `icon_xKDZI`,
	"moreButton": `moreButton_gZVWr`,
	"agentInfo": `agentInfo_ihl71`,
	"agentNameQuantityConversations": `agentNameQuantityConversations_ZKEpG`,
	"liSinHover": `liSinHover_Ihr9p`,
	"pinnedIconSvg": `pinnedIconSvg_yP1y3`,
	"active": `active_zuELQ`,
	"searchInputWrapper": `searchInputWrapper_QJget`,
	"searchIcon": `searchIcon_AG2Vy`,
	"searchInput": `searchInput_kjZad`,
	"verticalDots": `verticalDots_a8FOV`,
	"shadowContainer": `shadowContainer_zzMMm`,
	"noChats": `noChats_hLn69`,
	"asideBar": `asideBar_YziMQ`,
	"mobileMenu": `mobileMenu_x_h6L`,
	"searchContainerL": `searchContainerL_AEVNT`,
	"searchIconsWrappers": `searchIconsWrappers_b7d1Y`,
	"goToAgents": `goToAgents_mGqDk`,
	"selectedAgentContainer": `selectedAgentContainer_HkP7O`,
	"dotsWrapperHover": `dotsWrapperHover_RYyew`,
	"dotsWrapperHoverHorizontal": `dotsWrapperHoverHorizontal_WusFf`,
	"shadowContainerHorizontal": `shadowContainerHorizontal_qyWVk`,
	"communitiContainer": `communitiContainer_YYMj_`,
	"communiti": `communiti_YiPQl`,
	"imageHover": `imageHover_eMzkA`,
	"count": `count_GitNf`
};
export default ___CSS_LOADER_EXPORT___;
